import { render, staticRenderFns } from "./GivePage.vue?vue&type=template&id=0ebd4e6f"
import script from "./GivePage.vue?vue&type=script&lang=js"
export * from "./GivePage.vue?vue&type=script&lang=js"
import style0 from "./GivePage.vue?vue&type=style&index=0&id=0ebd4e6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports